import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.svg";
import logo_mob from "../img/logo.svg";
import MobileMenu from "./MobileMenu";

function Header() {
    const { t } = useTranslation();
    const location = useLocation();

    const languages = [
        { value: 'tr', label: 'TR' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    return (
        <div className="bg-[#F8F8F8]">
            <div className="hidden max-w-[1220px] h-[100px] justify-between mx-auto xl:flex items-center">
                <Link to="/"><img src={logo} alt="" className="w-[120px]"/></Link>
                <div className="flex items-center gap-[35px]">
                    <Link to="/trading"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/trading' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.1')}</p></Link>
                    <Link to="/accounts"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/accounts' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.2')}</p></Link>
                    <Link to="/fees"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/fees' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.3')}</p></Link>
                    <Link to="/bonus"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/bonus' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.4')}</p></Link>
                    <Link to="/support"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/support' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.5')}</p></Link>
                    <Link to="/about"><p className={`text-[16px] open-sans transition-all ${location.pathname === '/about' ? 'text-[#0BD752]' : 'text-[#353535]'}`}>{t('header.6')}</p></Link>
                    {/* <Dropdown
                        options={languages}
                        placeholder="EN"
                        onChange={handleChangeLang}
                        value={languages.find(lang => lang.value === currentLang)}
                    /> */}
                    <a href="http://user.dashboardcenter.ltd/">
                        <div className="button-h cursor-pointer">
                            <p className="inter text-white text-[16px] font-[700]">{t('header.b')}</p>
                        </div>
                    </a>
                </div>
              
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[60px]">
                <Link to="/"><img src={logo_mob} alt="" className="w-[100px]"/></Link>
                {/* <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                /> */}
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
